import React from 'react';
import { Avatar } from '@mui/material';
import Lightbox from '../Lightbox/Lightbox';
import './TalentAvatar.css';

// Get initials from name
const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};

const TalentAvatar = ({
  talent,
  width = '60px',
  height = '60px',
  background = '#bdbdbd',
  permitLightbox = false
}) => {
  return (
    <div
      className="talent-avatar-wrapper"
      style={{ width, height }}
    >
      {talent?.avatar && permitLightbox ? (
        <Lightbox
          image={talent.avatar}
          width="100%"
          height="100%"
          alt={`Avatar de ${talent?.name || 'usuário'}`}
          className="talent-avatar-lightbox"
        />
      ) : talent?.avatar ? (
        <div className="avatar-image-wrapper">
          <img src={talent.avatar} alt="Avatar" className="avatar-image" />
        </div>
      ) : (
        <Avatar
          className="default-avatar"
          sx={{
            width: '100%',
            height: '100%',
            fontSize: `calc(${Math.min(parseInt(width), parseInt(height))}px * 0.25)`,
            background
          }}
        >
          {getInitials(talent?.name) || "ND"}
        </Avatar>
      )}
    </div>
  );
};

export default TalentAvatar;
